var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('b-button', {
    staticClass: "mb-1",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.$emit('view', {
          component: 'ListPengembalian',
          pengembalian: null
        });
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ArrowLeftIcon"
    }
  }), _vm._v(" Kembali ")], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('small', {
    staticClass: "text-muted d-block mb-25"
  }, [_vm._v(_vm._s(_vm.item.no || "-"))]), _c('h4', {
    staticClass: "mb-2"
  }, [_vm._v("Detail Pengembalian")]), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Sales"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.item.sales ? _vm.item.sales.nama_lengkap : _vm.item.id_sales || "-") + " ")])])], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Tanggal Request"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.humanDate(_vm.item.tanggal)))])])], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Tujuan Gudang"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.item.gudang ? _vm.item.gudang.nama_gudang : _vm.item.id_gudang || "-") + " ")])])], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.item.keterangan || "-"))])])], 1)], 1)], 1), _c('h5', {
    staticClass: "mb-1"
  }, [_vm._v(" Rincian Barang "), _vm.rincian.length ? _c('span', [_vm._v("(" + _vm._s(_vm.rincian.length) + ")")]) : _vm._e()]), _c('b-card', [!_vm.rincian.length ? _c('div', {
    staticClass: "text-center text-muted py-3"
  }, [_vm._v(" Tidak ada rincian barang. ")]) : _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "bordered": "",
      "small": "",
      "fields": _vm.fields,
      "items": _vm.rincian
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(_ref) {
        var index = _ref.index;
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "cell(nama)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.barang ? _c('span', [_vm._v(_vm._s(item.barang.nama))]) : _c('i', {
          staticClass: "text-danger"
        }, [_vm._v("Barang tidak ditemukan")])];
      }
    }, {
      key: "cell(status)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.status && item.status.approve ? _c('feather-icon', {
          staticClass: "text-success",
          attrs: {
            "size": "20",
            "icon": "CheckCircleIcon"
          }
        }) : _c('feather-icon', {
          staticClass: "text-danger",
          attrs: {
            "size": "20",
            "icon": "XCircleIcon"
          }
        })];
      }
    }, {
      key: "cell(satuan)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [item.barang ? _c('span', [_vm._v(" " + _vm._s(item.barang.satuan ? item.barang.satuan.satuan : "-") + " ")]) : _c('i', {
          staticClass: "text-danger"
        }, [_vm._v("-")])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(_ref5) {
        var index = _ref5.index,
            item = _ref5.item;
        return [_vm.isSales && _vm.myGudang && _vm.myGudang.id && item.status && !item.status.approve ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            value: 'Hapus rincian',
            expression: "'Hapus rincian'",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.removeRincian(item, index);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        })], 1) : _c('feather-icon', {
          staticClass: "text-secondary",
          attrs: {
            "icon": "SlashIcon",
            "size": "18"
          }
        })];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }